export default {
	addMediafax: '/mediafax', //新增客户
	editMediafax: '/mediafax_new/{id}', //编辑客户
	getMediafaxList: '/mediafax_new/list', //社媒账号列表
	getMediafaxDetail: '/mediafax_new/', //获取详情
	getAuthUrl: '/mediafax/auth_url', //获取授权链接
	getPageList: '/mediafax_new/bm/page/list', //获取主页
	bindPage: '/mediafax/page', //绑定主页
	getMediafaxSubject: '/mediafax_new/param_subject', //根据客户查主体
	removeMediafaxAccount: '/mediafax/account/{id}', //删除账号
	getMediafaxAccount: '/mediafax/account/param_account', //运营账号联想
	homePageContent: '/instant_reply_ads/{id}', // 查询欢迎语，即时回复设置
	addWelcomeSpeech: '/instant_reply_ads/greeting', // 新增欢迎语
	updateWelcomeSpeech: '/instant_reply_ads/greeting/{id}', // 修改欢迎语
	addInstantReply: '/instant_reply_ads/instant_reply', // 新增即时回复
	updateInstantReply: '/instant_reply_ads/instant_reply', // 修改即时回复
	updateStatus: '/instant_reply_ads/instant_reply_offon/{id}', // 修改状态
	getPageRetrieve: '/mediafax_new/bm/page/retrieve', //检索主页列表
  platformBind: '/mediafax_new/platform-bind/{id}', // 平台绑定
  oauthAccount: '/mediafax_new/oauth-account/{id}', // 账号授权-返回授权链接
  oauthBind: '/mediafax_new/oauth-bind/{id}', // 账号授权更新-返回主页信息
};
